export default __webpack_public_path__ + "static/l4-hero-desktops-img-7f488497971371e19b4ca471efb29162.png";